import { colors, fonts } from '@grupoboticario/flora-tokens/revendedores/web/ds'

export const revendedores = {
  colors,
  fonts,
}
